// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dam-4"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3H21C21 9 21 15.4651 21 21H3V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M15 21V11H9V21H15Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 21V11H12M15 21H21C21 15.4651 21 9 21 3H12M15 21H9M9 21V11H12M9 21H3V3H12M12 3V11","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dam-4')
export default class Dam4Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-4',
    }
  }
}
